/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var PageableCollection = require('psa-backbone/models/PageableCollection');

var PlaceholderView = require('common/views/PlaceholderView');

var CorpFinFeesSectionView = require('../views/CorpFinFeesSectionView');
var GetFeesByRecord = require('../services/GetFeesByRecord');

module.exports = {
  channel: 'cf',

  event: 'build:corp-fin-fees-section-view',

  builder: function(recordId, recordCategoryId, isReadOnly) {
    return new PlaceholderView({
      viewPromise: buildCorpFinFeesSectionView(recordId, recordCategoryId, isReadOnly)
    });
  }
};

function buildCorpFinFeesSectionView(recordId, recordCategoryId, isReadOnly) {
  var deferred = $.Deferred();
  GetFeesByRecord(recordId)
    .done(function(fees) {
      deferred.resolve(
        new CorpFinFeesSectionView({
          collection: new PageableCollection(fees, { pageSize: 25 }),
          recordCategoryId: recordCategoryId,
          isReadOnly: isReadOnly
        })
      );
    })
    .fail(function(err) {
      deferred.reject(err);
    });
  return deferred.promise();
}
